export default {
  methods: {
    toCurrency(value, lang = 'fr-FR', currency = 'EUR') {
      if (typeof value !== 'number') {
        return value;
      }
      let formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return formatter.format(value);
    },
  },
};
